(function () {
	'use strict';

	var STORAGE_KEY = 'yesmeBuyerContext';
	var current = window.yesmeBuyerContext;

	if (!current) {
		return;
	}

	function readPrevious() {
		try {
			return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
		} catch (error) {
			return null;
		}
	}

	function saveCurrent() {
		try {
			window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
				customerId: current.customerId,
				locationId: current.locationId,
				priceListId: current.priceListId
			}));
		} catch (error) {
			// Ignore quota / private mode.
		}
	}

	function sameBuyer(previous, next) {
		return previous.customerId === next.customerId
			&& previous.locationId === next.locationId
			&& previous.priceListId === next.priceListId;
	}

	var previous = readPrevious();

	if (!previous || sameBuyer(previous, current)) {
		saveCurrent();
		return;
	}

	fetch('/cart.js')
		.then(function (response) {
			return response.json();
		})
		.then(function (cart) {
			if (!cart.item_count) {
				saveCurrent();
				return;
			}

			return fetch('/cart/clear.js', {
				method: 'POST',
				headers: { Accept: 'application/json' }
			}).then(function (response) {
				if (!response.ok) {
					throw new Error('cart clear failed');
				}

				saveCurrent();
				window.location.reload();
			});
		})
		.catch(function () {
			// Keep the previous fingerprint so the next page load retries.
		});
})();
